<template>
    <div class="modal" :class="{'is:on': status}">
        <div class="modal_inner">
            <div class="modal_txt">{{msg}}</div>
            <div class="modal_ctrl">
                <button class="btn w:full clr:primary" @click="modalStatus">確定</button>
            </div>
        </div>
        <div class="modal_overlay"></div>
    </div>
</template>

<script>

export default {
    name: 'modal',
    props: {
        msg: String,
        status: Boolean
    },
    watch:{
        status(val){
            console.log(val)
            document.querySelector('body').style.overflow = !val?'visible':'hidden'
        }
    },
    methods: {
        modalStatus() {
            // console.log('close')
            document.querySelector('body').style.overflow = 'visible'
            this.$emit('close');
        },
    },
}
</script>
<style lang="scss" scoped>
.modal {
    &_inner {
         position: relative;
         z-index: 2;
         border: 1px solid #e6e6e6;
         padding: 20px;
         border-radius: 3px;
         background: white;
         width: 70%;
         max-width: 400px;
     }

    &.is\:on {
        z-index: 1000;
        pointer-events: auto;
        opacity: 1;
    }

    &_overlay {
         position: absolute;
         top: 0;
         left: 0;
         width: 100%;
         height: 100%;
         z-index: 1;
         background-color: rgba(0, 0, 0, 0.72);
     }

    &_txt {
         text-align: center;
         margin-bottom: 1.5rem;
     }
}
</style>
